import axios from 'axios';
import { endpoints } from '@/api/endpoints.js';
import { baseURL } from '../../../api/environment';

const URL = baseURL;

/**
 * Valida si el cliente ya existe en el sistema
 */
export const sendValidateCustomer = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const endpoint = endpoints.checkout.validateCustomer.endpoint;
        const token = await rootState.Token.token.dataObj;

        const responseData = {
            correo: params.email
        };
        
        console.log('sendValidateCustomer - Enviando validación:', responseData);
        console.log('sendValidateCustomer - Token:', token);
        console.log('sendValidateCustomer - Endpoint:', endpoint);
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                ...responseData
            }
        });
        
        console.log('sendValidateCustomer - Respuesta completa:', data);
        
        if (data.res) {
            commit('SET_CUSTOMER_VALIDATION', data.res);
        } else {
            commit('SET_CUSTOMER_VALIDATION', data.res);
            console.error('sendValidateCustomer - Validación falló:', data.msg);
        }
    } catch (err) {
        console.error('sendValidateCustomer - Error en la petición:', err);
        console.error('sendValidateCustomer - Error response:', err.response);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
        commit('SET_CUSTOMER_VALIDATION', false);
    } finally {
        commit('SET_LOADING', false);
    }
};
